export default "__VITE_ASSET__CYsFuRv6__"